import React from "react";
import clsx from "clsx";
import { A } from "../styles/appleClasses";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "outline" | "danger" | "tertiary";
  minWidth?: string; // default: "120px"
  children: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  minWidth = "120px",
  className = "",
  children,
  leftIcon,
  rightIcon,
  ...rest
}) => {
  const { style, ...btnRest } = rest;

  const variantClass =
    variant === "primary"
      ? A.btnPrimary
      : variant === "secondary"
      ? A.btnSecondary
      : variant === "outline"
      ? A.btnOutline
      : variant === "tertiary"
      ? A.btnTertiary
      : A.btnDanger;

  

  return (
    <button
      className={clsx(A.btnBase, variantClass, className)}
      style={{ minWidth, ...(style || {}) }}
      {...btnRest}
    >
      <span className="inline-flex items-center justify-center gap-2">
        {leftIcon ? <span className="shrink-0">{leftIcon}</span> : null}
        <span className="whitespace-nowrap">{children}</span>
        {rightIcon ? <span className="shrink-0">{rightIcon}</span> : null}
      </span>
    </button>
  );
};
